import baseStoreDefaults from '../sr1performance/config.js';
import shopifyGenericDefaults from '../shopify-generic/config.js';

const corvetteCollectionRegex = /^\/collections\/c\d+-corvette-parts-accessories/i;

function parseMegaMenuParent() {
  const pathname = window.location.pathname.replace(window.Convermax.Shopify.getRootRoute(), '');
  if (!corvetteCollectionRegex.test(pathname)) {
    return;
  }

  const parentLiElement = document.getElementById('primary-menu');
  if (!parentLiElement) {
    return;
  }

  const [, , collectionSegment = ''] = pathname.split('/');
  const [corvetteGeneration = ''] = collectionSegment.split('-');

  const navMenuParentElements = parentLiElement.querySelectorAll('.item-menu-bottom[data-parent-title]');
  const items = [];

  navMenuParentElements.forEach((parentEl) => {
    const parentTitle = parentEl.getAttribute('data-parent-title')?.toLowerCase();
    if (!parentTitle.startsWith(corvetteGeneration)) {
      return;
    }

    parentEl.querySelectorAll('.products a').forEach((linkElement) => {
      const imageElement = linkElement.querySelector('img');
      const titleElement = linkElement.querySelector('.title');

      const item = {
        value: titleElement ? titleElement.textContent.trim() : '',
        href: linkElement.getAttribute('href') || '',
        imageUrl: imageElement ? imageElement.getAttribute('src') || '' : '',
      };

      items.push(item);
    });
  });

  if (items.length > 0) {
    window.Convermax.corvetteMegaMenu = items;
  }
}

const InitFunc = () => {
  baseStoreDefaults.InitFunc?.();
  parseMegaMenuParent();
};

export default {
  ...baseStoreDefaults,
  InitFunc,
  includes: ['shopify-generic', 'sr1performance'],
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['HeaderVehicleWidget'].includes(w.name)),
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      initCollapsed: true,
    },
  ],
};
